/**
 * Controlled onboarding step constants
 * step_name values must come from this set - no free-form strings
 * These represent screen/page names for drop-off tracking
 */
export const OnboardingSteps = {
  EMAIL_VERIFICATION: 'email_verification',
  WELCOME: 'welcome',
  MOTIVATION: 'motivation',
  SET_PERSONAL_INFO: 'set_personal_info',
  FACE_ANALYSIS: 'face_analysis',
  DIGITAL_FOOTPRINT: 'digital_footprint',
  BEHAVIOR_DETECTION: 'behavior_detection',
} as const

export type OnboardingStepName =
  (typeof OnboardingSteps)[keyof typeof OnboardingSteps]

/**
 * Step index mapping for funnel analysis
 * Indices are 0-based and reflect the order users progress through onboarding
 */
export const OnboardingStepIndex: Record<OnboardingStepName, number> = {
  [OnboardingSteps.EMAIL_VERIFICATION]: 1,
  [OnboardingSteps.WELCOME]: 2,
  [OnboardingSteps.MOTIVATION]: 3,
  [OnboardingSteps.SET_PERSONAL_INFO]: 4,
  [OnboardingSteps.DIGITAL_FOOTPRINT]: 5,
  [OnboardingSteps.FACE_ANALYSIS]: 6,
  [OnboardingSteps.BEHAVIOR_DETECTION]: 7,
}

/**
 * KYC (Know Your Customer) verification step constants
 */
export const KYCSteps = {
  VERIFICATION_START: 'kyc_verification_start',
  IN_PROGRESS: 'kyc_in_progress',
  SUCCESS: 'kyc_success',
  FAILED: 'kyc_failed',
} as const

export type KYCStepName = (typeof KYCSteps)[keyof typeof KYCSteps]

/**
 * Step index mapping for KYC funnel analysis
 */
export const KYCStepIndex: Record<KYCStepName, number> = {
  [KYCSteps.VERIFICATION_START]: 1,
  [KYCSteps.IN_PROGRESS]: 2,
  [KYCSteps.SUCCESS]: 3,
  [KYCSteps.FAILED]: 3, // Same level as success, different outcome
}

export const AuthMethods = {
  EMAIL: 'email',
  GOOGLE: 'google',
  VSL: 'vsl',
} as const

export enum ELoginType {
  WorldCup = 'wc',
  Universities = 'un',
  Visas = 'vi',
  Hiring = 'hr',
}

export enum ELoginFrom {
  Instagram = 'instagram',
  Facebook = 'facebook',
  Twitter = 'twitter',
  TikTok = 'tiktok',
  LinkedIn = 'linkedin',
  Pinterest = 'pinterest',
  Reddit = 'reddit',
}
